import { styled } from 'styled-components';

const LimitBadge = styled.span.withConfig({
  displayName: "LimitBadge",
  componentId: "sc-15d0a0e8-0"
})([
  `display:flex;padding:4px 10px;flex-direction:column;align-items:flex-start;gap:10px;border-radius:14px;background:rgba(255,0,0,0.1);color:#f00;font-size:14px;font-style:normal;font-weight:500;line-height:normal;`
]);

export { LimitBadge };
//# sourceMappingURL=LimitBadge.js.map
